export const CHANGE_DISPLAY_TOGGLE_LOCATION_VIEW_HEADER = "@@LOCATION_ROUTER/CHANGE_DISPLAY_TOGGLE_LOCATION_VIEW_HEADER" as const;
export const CHANGE_LOCATION_ROUTER_VIEW = "@@LOCATION_ROUTER/CHANGE_LOCATION_ROUTER_VIEW" as const;
export const CHANGE_USE_NEW_LOCATION_SELECTION_UI = "@@LOCATION_ROUTER/CHANGE_USE_NEW_LOCATION_SELECTION_UI" as const;

export const changeDisplayToggleLocationViewHeader = (payload: boolean) => ({
  type: CHANGE_DISPLAY_TOGGLE_LOCATION_VIEW_HEADER,
  payload
} as const);

export const changeLocationRouterView = (payload: "list" | "map") =>
  ({
    type: CHANGE_LOCATION_ROUTER_VIEW,
    payload
  } as const);

export const changeUseNewLocationSelectionUI = (payload: boolean) => ({
  type: CHANGE_USE_NEW_LOCATION_SELECTION_UI,
  payload
} as const)


export type ChangeLocationViewActions =
  | ReturnType<typeof changeDisplayToggleLocationViewHeader>
  | ReturnType<typeof changeLocationRouterView>
  | ReturnType<typeof changeUseNewLocationSelectionUI>;
